let globalLoadPanelInstance = null;

export const setLoadPanelInstance = (instance) => {
  globalLoadPanelInstance = instance;
}

export const showLoadPanel = () => {
  globalLoadPanelInstance.show();
};

export const hideLoadPanel = () => {
  globalLoadPanelInstance.hide();
};
